import React, { useState, useEffect } from 'react'
import { NavItem, Nav, NavDropdown, MenuItem } from 'react-bootstrap'
import { NavLink, Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux'

import { firebaseAuth, firebaseDb as db } from '../../firebase'
import languages from '../../data/languages.json'
import CalPublish from '../../views/CalPublish/CalPublish'
import CalDelete from '../CalDelete'

const HeaderLinks = props => {
  const [authName, setAuthName] = useState('Loading...')
  const [calendarData, setCalendarData] = useState()
  const [demoId, setDemoId] = useState()
  const [expirationDate, setExpirationDate] = useState()
  const [isCalendarDisabled, setCalendarDisabled] = useState(false)

  // Redux
  const {
    activeCalendar,
    activeCompany,
    companiesData,
    calendarLang,
    calendarLangs
  } = useSelector(state => state)
  const dispatch = useDispatch()

  useEffect(() => {
    const user = firebaseAuth.currentUser
    let userDisplayName

    if (user) {
      userDisplayName = user.displayName
    }

    setAuthName(userDisplayName)
  })

  // Load languages and save to redux
  useEffect(() => {
    activeCompany &&
      activeCalendar &&
      // Get demoId everytime it is updated
      db
        .doc(
          'companies/' +
          activeCompany +
          '/calendars/' +
          activeCalendar
        )
        .onSnapshot((querySnapshot) => {
          const data = querySnapshot.data()
          if(data) {
            setCalendarDisabled(data.disabled)
          }
          if(!data || !data.demoId) return; 
          setDemoId(data.demoId)
        })
    activeCompany &&
      activeCalendar &&
      db
        .doc(
          'companies/' +
          activeCompany +
          '/calendars/' +
          activeCalendar +
          '/settings/grid'
        )
        .get()
        .then(async querySnapshot => {
          let data = querySnapshot.data()
          changeCalendarLanguage(data.languagePrimary, data.languagePrimary)
          dispatch({ type: 'CHANGE_CALENDAR_LANGS', value: data.languages })
        })

    activeCompany &&
      activeCalendar &&
      // Get translated document
      db
        .doc(
          'companies/' +
          activeCompany +
          '/calendars/' +
          activeCalendar +
          '/settings/grid'
        )
        .get()
        .then(querySnapshot => {
          const data = querySnapshot.data()
          setCalendarData(data)
        })
  }, [activeCompany, activeCalendar])

  useEffect(() => {
    const user = firebaseAuth.currentUser
    let userDisplayName

    if (user) {
      userDisplayName = user.displayName
    }

    setAuthName(userDisplayName)
  })

  useEffect(() => {
    if (activeCompany && companiesData ) {
      setExpirationDate(companiesData[activeCompany].validUntil.toDate())
    }
  }, [activeCompany, companiesData])

  const changeCompanyHandler = newCompany => {
    dispatch({ type: 'CHANGE_ACTIVE_COMPANY', value: newCompany })
    props.history.push('/company/' + newCompany + '/dashboard')
    dispatch({ type: 'CHANGE_ACTIVE_CALENDAR', value: null })
  }

  const changeCalendarHandler = newCalendar => {
    dispatch({ type: 'CHANGE_ACTIVE_CALENDAR', value: newCalendar })
    props.history.push(
      '/company/' + activeCompany + '/calendar/' + newCalendar + '/dashboard'
    )
  }

  const homeDashboardHandler = () => {
    dispatch({ type: 'CHANGE_ACTIVE_COMPANY', value: null })
    dispatch({ type: 'CHANGE_ACTIVE_CALENDAR', value: null })
    props.history.push('/dashboard')
  }

  const changeCalendarLanguage = (lng, primary) => {
    dispatch({ type: 'CHANGE_CALENDAR_LANG', value: { lang: lng, primary } })
  }

  const { t, location } = props

  // Not permission for company
  if (
    activeCompany &&
    companiesData &&
    typeof companiesData[activeCompany] === 'undefined'
  ) {
    homeDashboardHandler()
  }

  const styleActiveLanguage = {
    border: '3px solid #87CB16',
    marginTop: '1px',
    marginLeft: '5px'
  }
  const styleLanguage = {
    marginLeft: '5px'
  }

  const isDev = process.env.NODE_ENV === 'development'
  const isStaging = process.env.REACT_APP_FIREBASE_PROJECT === 'w4-calendar-builder-dev'
  const previewDomain = isDev
    ? 'http://localhost:3001'
    : isStaging ? 'https://w4-advent-calendar-dev.firebaseapp.com' : 'https://w4-calendar.firebaseapp.com'
  const baseUrl = process.env.REACT_APP_BASE_URL_PAYMENT
  const currentDate = new Date()

  return (
    <div>
      {props.type === 'dashboard' && (
        <div>
          <Nav>
            <NavItem onClick={e => homeDashboardHandler()}>
              <i className='pe-7s-home' style={{ fontSize: '20px' }} />
            </NavItem>
            {/* <NavItem disabled>
                <i className='pe-7s-users' style={{ fontSize: '20px' }} />
              </NavItem> */}
            <NavDropdown
              eventKey={2}
              title={
                <span>
                  {activeCompany
                    ? companiesData &&
                    companiesData[activeCompany] &&
                    companiesData[activeCompany].name
                    : 'Company'}
                </span>
              }
              id='basic-nav-dropdown-right'
            >
              {companiesData &&
                _.map(companiesData, (company, index) => {
                  return (
                    <MenuItem
                      onClick={() => changeCompanyHandler(index)}
                      key={index}
                    >
                      {company.name}
                    </MenuItem>
                  )
                })}
            </NavDropdown>
          </Nav>

          {activeCompany &&
            companiesData &&
            companiesData[activeCompany] &&
            companiesData[activeCompany].numCalendars !== 0 && (
              <Nav>
                <NavDropdown
                  eventKey={2}
                  title={
                    <span>
                      {' '}
                      {activeCalendar &&
                        companiesData &&
                        companiesData[activeCompany] && companiesData[activeCompany].calendars[
                            activeCalendar
                          ] ? (
                        <span>
                          <i className='dot-active' />{' '}
                          {companiesData[activeCompany].calendars[
                            activeCalendar
                          ].name +
                            ' (' +
                            companiesData[activeCompany].calendars[
                              activeCalendar
                            ].type +
                            ')'}
                        </span>
                      ) : (
                        'Select a calendar'
                      )}
                    </span>
                  }
                  id='basic-nav-dropdown-right'
                >
                  <MenuItem disabled>Active:</MenuItem>
                  {companiesData &&
                    _.map(
                      companiesData[activeCompany].calendars,
                      (calendar, index) => {
                        if(calendar.disabled) return;
                        return (
                          <MenuItem
                            onClick={() => changeCalendarHandler(index)}
                            key={index}
                          >
                            <i className='dot-active' />{' '}
                            {calendar.name + ' (' + calendar.type + ')'}
                          </MenuItem>
                        )
                      }
                    )}
                  <MenuItem divider />
                  <MenuItem
                    componentClass={NavLink}
                    href='/'
                    to={'/company/' + activeCompany + '/create-new-calendar'}
                  >
                    <i className='fa fa-plus' /> {t('header.createNew')}
                  </MenuItem>
                </NavDropdown>
              </Nav>
            )}

          {activeCompany && (
            <React.Fragment key={`${activeCompany} ${activeCalendar}`}>
              {/* TODO: use quick publish button instead? */}
              {/* <Link
                to={
                  '/company/' +
                  activeCompany +
                  '/calendar/' +
                  activeCalendar +
                  '/calpublish'
                }
              >
                <button className='btn btn-xs btn-warning' id='btn-publish'>
                  {t('sidebar.publish')}
                </button>
              </Link> */}

              {activeCalendar && isCalendarDisabled !== true ? (
                <>
                  {/* TODO: finish quick publish button */}
                  {companiesData && <CalPublish buttonView />}

                  <a
                    href={`${previewDomain}/?companyId=${activeCompany}&calendarId=${activeCalendar}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn btn-xs btn-sucesss'
                  >
                    {t('sidebar.livePreview')}
                  </a>
                  {/* TODO: finish quick publish button */}
                  {companiesData && <CalPublish buttonView demo />}
                  
                  <a
                    href={demoId && `${previewDomain}/?companyId=${activeCompany}&calendarId=${activeCalendar}&demo=${demoId}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn btn-xs btn-sucesss'
                  >
                    {t('sidebar.demoPreview')}
                  </a>
                </>
              ) : (location.pathname !== '/dashboard' &&
                <>
                  <Link to={'/company/' + activeCompany + '/create-new-calendar'}>
                    <button className='btn btn-xs btn-success'>
                      {t('header.createNewCalendar')}
                    </button>
                  </Link>
                  {expirationDate < currentDate && isStaging ? (
                    <a className='btn btn-xs btn-danger'
                       href={'https://www.' + baseUrl + '/advent-calendar?companyId=' + activeCompany }
                       rel="noopener noreferrer">
                      {t('header.extendLicense')}
                    </a>
                    ) : ''
                  }
                </>
              )}
            </React.Fragment>
          )}
          <Nav pullRight>
            {activeCalendar && 
                <CalDelete notificationOpen={props.notificationOpen} />
            }
          </Nav>
          <Nav pullRight>
            {activeCalendar && calendarLangs && (
              <>
                <NavItem disabled>{t('header.calendarLanguage')}</NavItem>
                <NavItem>
                  {_.map(calendarLangs, (lang, index) => {
                    return (
                      <img
                        key={index}
                        style={
                          calendarLang === index
                            ? styleActiveLanguage
                            : styleLanguage
                        }
                        onClick={() =>
                          changeCalendarLanguage(
                            index,
                            calendarData.languagePrimary
                          )
                        }
                        alt={languages[index].name}
                        src={languages[index].icon}
                      />
                    )
                  })}
                </NavItem>
              </>
            )}

            {/* {this.props.activeCompany && (
                <NavItem componentClass={NavLink} href='/' to={'/company/' + this.props.activeCompany + '/account'}>
                  Account & Billing
                </NavItem>
              )} */}
            <NavItem disabled>{authName}</NavItem>
            <NavItem componentClass={NavLink} href='/' to='/auth/logout'>
              {t('header.logout')}
            </NavItem>
          </Nav>
        </div>
      )}
      {props.type === 'auth' && (
        <div>
          <Nav>
            <NavItem>{t('header.productPage')}</NavItem>
          </Nav>
          <Nav pullRight>
            <NavItem>
              <img
                style={
                  calendarLang === 'en' ? styleActiveLanguage : styleLanguage
                }
                onClick={() => changeCalendarLanguage('en')}
                alt='English language'
                src='data:image/png;base64,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'
              />
              <img
                style={
                  calendarLang === 'de' ? styleActiveLanguage : styleLanguage
                }
                onClick={() => changeCalendarLanguage('de')}
                alt='German language'
                src='data:image/png;base64,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'
              />
            </NavItem>
            <NavItem componentClass={NavLink} href='/' to='/auth/login'>
              {t('header.login')}
            </NavItem>
            <NavItem componentClass={NavLink} href='/' to='/auth/register'>
              {t('header.register')}
            </NavItem>
          </Nav>
        </div>
      )}
    </div>
  )
}

export default translate('translations')(HeaderLinks)
